import {
  sendWorkBadgeEmailRequestSchema,
  type SendWorkBadgeEmailResponse,
  sendWorkBadgeEmailResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

interface SendWorkBadgeEmailParams {
  workerId: string;
  qualification: string;
}

export function useSendWorkBadgeEmail(
  options: UseMutationOptions<SendWorkBadgeEmailResponse, Error, SendWorkBadgeEmailParams> = {}
) {
  return useMutation({
    mutationFn: async ({ workerId, qualification }) => {
      const response = await post({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/workers/${workerId}/work-badge-emails`,
        data: {
          data: {
            type: "work-badge-email",
            attributes: {
              qualification,
            },
          },
        },
        requestSchema: sendWorkBadgeEmailRequestSchema,
        responseSchema: sendWorkBadgeEmailResponseSchema,
      });

      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.WORK_BADGE_EMAIL_SEND_FAILURE,
    },
    ...options,
  });
}
